import Numeral from 'numeral'

window.az = new Object()

az.numeral = Numeral

az.findInArr = function(array, val){
    for(var i=0; i<array.length; i++){
        if(array[i] == val)
        return true
    }
    return false
}

az.formatCurrency = function (val) {
    return az.numeral(val).format('0,000.00')
},

az.page = function () {
    return app.$route.matched[0].instances.default
}

// Handle click outside to close dropdown menus
az.hideOnClickOutside = function (id, excluded) {
    function outsideClickListener(event) {
        if (!excluded.includes(event.target.id)) {
            document.getElementById(id).classList.remove('is-active')
            removeClickListener()
        }
    }
    function removeClickListener() {
        document.removeEventListener('click', outsideClickListener)
    }
    document.addEventListener('click', outsideClickListener)
}

az.removeFromArr = function (array, params) {

    array.some(function (item, index) {
        if (array[index][params.key] == params.value) {
            array.splice(index, 1)
            return true
        }
        return false
    })
    return array
}
// remove trailing slashes from path
az.noSlash = function (path) {
    return path.replace(/\/+$/, '')
}

az.addRemSpinner = function (addRem, classId, id) {
    if (addRem) {
        if (classId == 'class') {
            var el = document.getElementsByClassName(id)
            for (var i = 0; i < el.length; i++) {
                el.item(i).classList.add('is-loading')
            }
        } else {
            if(document.getElementById(id) != undefined)
                document.getElementById(id).classList.add('is-loading');
        }
    } else {
        if (classId == 'class') {
            var el = document.getElementsByClassName(id)
            for (var i = 0; i < el.length; i++) {
                el.item(i).classList.remove('is-loading')
            }
        } else {
            if(document.getElementById(id) != undefined)
                document.getElementById(id).classList.remove('is-loading');
        }
    }
}

az.dateConvert = function(date){
    var d = new Date(date);
    return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`
}

az.dateConvertAddAYear = function(date){
    if(date == ''){
        return ''
    }

    var d = new Date(date);
    d.setFullYear(d.getFullYear() + 1);
    return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`
}

az.dateCalc = function(dt, code){
    var dt = new Date(dt)
   
    if(dt == ''){
        return ''
    }


    function getNextMonthDate(date) {
        var currentMonth = date.getMonth();
        var currentYear = date.getFullYear();

       
        var nextMonth = currentMonth + 1

      
      
        if (nextMonth === 12) { // if next month is January of next year
          currentYear++;
          nextMonth = 0
        }

        var lastDayOfMonth = new Date(2023, nextMonth + 1, 0).getDate();

        if (lastDayOfMonth < date.getDate()) { // if next month has fewer days than the current month
            return `${nextMonth +1}/${lastDayOfMonth}/${currentYear}`
        }
      
        return `${nextMonth + 1}/${date.getDate()}/${currentYear}`
    }

    
    if(code.split('Monthly').length > 1){
        return getNextMonthDate(new Date(dt))
    } else if(code.split('Yearly').length > 1){
        return `${dt.getMonth() + 1}/${dt.getDate()}/${dt.getFullYear() + 1}`
    } else {
       return '-No expiration'
    }
       

}

az.dateConvertAdd30 = function(date){
    if(date == ''){
        return ''
    }

    var d = new Date(date);
    d.setDate(d.getDate() + 30);
    return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`
}

az.getCookie = function(cookieName){
    var arr = document.cookie.split('; ');
    for (var i=0; i < arr.length; i++){
        var temp = arr[i].split('=');
        if(temp[0] == cookieName){
            return temp[1];
        } 
    }
    return ''
}

az.deleteCookie =function(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

az.checkURL = function(url){
    var regex = /^[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,10}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/
    return url.match(regex)
}

az.checkEmail = function(email){
    var regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    return email.match(regex)
}

az.checkPhone = function(phone){
    var regex = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/     //    /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
    return phone.match(regex)
}



// WEBPACK FOOTER //
// ./src/helpers/az.js